import { render, staticRenderFns } from "./item.vue?vue&type=template&id=0159e315&class=crud-item-grid"
import script from "./item.ts?vue&type=script&lang=js&external"
export * from "./item.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0159e315')) {
      api.createRecord('0159e315', component.options)
    } else {
      api.reload('0159e315', component.options)
    }
    module.hot.accept("./item.vue?vue&type=template&id=0159e315&class=crud-item-grid", function () {
      api.rerender('0159e315', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/manipulacaoNew/item.vue"
export default component.exports